import React, { useState, createContext } from 'react'

export const ResultsContext = createContext(null)

export const ResultsContextProvider = ({ children }) => {  
  const [currentItemIndex, setCurrentItemIndex] = useState(0)

  const [autoplay, setAutoplay] = useState(true)
  const [autoplaySpeed, setAutoplaySpeed] = useState(10000)

  const [resultSliderRef, setResultSliderRef] = useState(null)
  const [thumbnailSliderRef, setThumbnailSliderRef] = useState(null)  

  const goToSlide = index => {
    resultSliderRef.slickGoTo(index)
  }

  const nextSlide = () => {
    goToSlide(currentItemIndex + 1)
  }

  const prevSlide = () => {
    goToSlide(currentItemIndex - 1)
  }

  const value = {
    currentItemIndex, setCurrentItemIndex,
    autoplay, setAutoplay,
    autoplaySpeed, setAutoplaySpeed,
    resultSliderRef, setResultSliderRef,
    thumbnailSliderRef, setThumbnailSliderRef,
    goToSlide,
    nextSlide,
    prevSlide
  }

  return (
    <ResultsContext.Provider value={value}>
      {children}
    </ResultsContext.Provider>
  )
}